module.exports = __webpack_public_path__ + "static/media/FontsFree-Net-DS-DIGI-2.63f874d1.ttf";